import { Col, Table } from 'antd'
import { Button } from 'components/atoms'
import { FilterLayout } from 'components/templates'
import styled from 'styled-components'

export const StyledTable = styled(Table)<any>`
  min-height: 0;
  flex: 1;
`
export const StyledTStauts = styled(Col)<any>``

export const StyledFilterLayout = styled(FilterLayout)`
  padding: 8px 16px 0px 16px;
`
export const StyledBtn = styled(Button)`
  margin-right: 8px;
`
export const StyledBtnSetting = styled(Button)`
  margin-right: 8px;
`
